import { render } from "./VideoSection.vue?vue&type=template&id=0a9235a0&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"

import "./VideoSection.vue?vue&type=style&index=0&id=0a9235a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9235a0"]])

export default __exports__